import { productApi } from '../api';

export const productRepo = {
    
    // PRODUCT TYPES
    getProductTypes: (params) => productApi.getProductTypes(params),
    getActiveProductTypes: () => productApi.getActiveProductTypes(),
    getProductTypeById: (productTypeId) => productApi.getProductTypeById(productTypeId),
    createProductType: (data) => productApi.createProductType(data),
    updateProductType: (productTypeId, data) => productApi.updateProductType(productTypeId, data),
    toggleProductTypeStatus: (productTypeId) => productApi.toggleProductTypeStatus(productTypeId),

    // PRODUCT CATEGORIES
    getProductCategories: (params) => productApi.getProductCategories(params),
    getActiveProductCategories: () => productApi.getActiveProductCategories(),
    getProductCategoriesByProductType: (productTypeId) => productApi.getProductCategoriesByProductType(productTypeId),
    getProductCategoryById: (productCategoryId) => productApi.getProductCategoryById(productCategoryId),
    createProductCategory: (data) => productApi.createProductCategory(data),
    updateProductCategory: (productCategoryId, data) => productApi.updateProductCategory(productCategoryId, data),
    toggleProductCategoryStatus: (productCategoryId) => productApi.toggleProductCategoryStatus(productCategoryId),

    // PRODUCTS
    getProducts: (params) => productApi.getProducts(params),
    getActiveProducts: () => productApi.getActiveProducts(),
    getProductById: (productId) => productApi.getProductById(productId),
    getProductByCategory: (productCategoryId) => productApi.getProductByCategory(productCategoryId),
    getPackageTypes: () => productApi.getPackageTypes(),
    createProduct: (data) => productApi.createProduct(data),
    updateProduct: (productId, data) => productApi.updateProduct(productId, data),
    toggleProductStatus: (productId) => productApi.toggleProductStatus(productId),
};